import { concat, orderBy, uniqBy } from "lodash";
import { SignalingLogListStateType } from "./types";
import { createReducer } from "@reduxjs/toolkit";
import { setSignalingLogList } from "./actions";

const initialState: SignalingLogListStateType = {
  signalingLogList: [],
};

export const signalingLogListReducer = createReducer(initialState, (builder) => {
  builder.addCase(setSignalingLogList, (state, action) => {
    state.signalingLogList = uniqBy(orderBy(concat(state.signalingLogList, action.payload), ["offerTime"], ["desc"]), "id");
  });
});
